import React, { useRef, useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Container, Row, Col, Form, FormGroup, Label, Input, Button } from "reactstrap";
import { FiMapPin, FiMail, FiClock, FiSmartphone } from "react-icons/fi";
import axios from "axios";
import ExamplesNavbar from "../../components/Navbars/ExamplesNavbar";
import ContactPageHeader from "../../components/Headers/ContactPageHeader";
import DefaultFooter from "../../components/Footers/DefaultFooter";
import Swal from "sweetalert2";

const ContactPage = () => {
    const form = useRef(null);
    const [contactInfo, setContactInfo] = useState({
        email: "",
        alamat: "",
        jamkerja: "",
    });

    const fetchContactInfo = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/kontak/readKontak`);
            const data = response.data;
    
            if (Array.isArray(data) && data.length > 0) {
                setContactInfo(data[0]);
            } else {
                console.warn("Contact info data is empty or not an array");
            }
        } catch (error) {
            console.error("Error fetching contact info:", error);
        }
    };
    

    useEffect(() => {
        fetchContactInfo();

        // Initialize AOS
        AOS.init({
            duration: 800, // Duration of animation in ms
            easing: "ease-in-out", // Easing function for animation
            once: true, // Trigger animation only once
        });
    }, []);

    const sendEmail = async (e) => {
        e.preventDefault();
    
        if (form.current) {
            const formData = new FormData(form.current);
    
            try {
                const response = await axios.post(`${process.env.REACT_APP_API_URL}/send`, {
                    user_name: formData.get("user_name"),
                    user_email: formData.get("user_email"),
                    subject: formData.get("subject"),
                    message: formData.get("message"),
                });
    
                if (response.status === 200) {
                    Swal.fire({
                        icon: "success",
                        title: "Berhasil!",
                        text: "Pesan kamu telah dikirim. Terima kasih!",
                    });
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Oops!",
                        text: "Terjadi kesalahan, pesan kamu gagal dikirim.",
                    });
                }
            } catch (error) {
                console.error("There was an error!", error);
                Swal.fire({
                    icon: "error",
                    title: "Oops!",
                    text: "Terjadi kesalahan, pesan kamu gagal dikirim.",
                });
            }
        } else {
            console.error("Form reference is null.");
        }
    };

    useEffect(() => {
        document.body.classList.add("profile-page");
        document.body.classList.add("sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;

        return function cleanup() {
            document.body.classList.remove("profile-page");
            document.body.classList.remove("sidebar-collapse");
        };
    }, []);

    const iconTextStyle = {
        display: "flex",
        alignItems: "center",
        gap: "10px",
    };

    return (
        <>
            <ExamplesNavbar />
            <div className="wrapper">
                <ContactPageHeader />
                <div className="section">
                    <Container>
                        <Row className="text-center mb-4" data-aos="fade-up">
                            <Col>
                                <p>
                                    Jika Anda memiliki pertanyaan atau membutuhkan informasi,
                                    silahkan hubungi kami atau mengisi formulir di bawah ini:
                                </p>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="6" data-aos="fade-right">
                                <div className="info">
                                    <div className="address">
                                        <h4 style={{ fontSize: "18px" }}>Lokasi:</h4>
                                        <div style={{ ...iconTextStyle, fontSize: "14px" }}>
                                            <FiMapPin
                                                style={{ marginBottom: "20px", fontSize: "30px" }}
                                            />
                                            <p>{contactInfo.alamat}</p>
                                        </div>
                                    </div>
                                    <div className="email">
                                        <h4 style={{ fontSize: "18px" }}>Email:</h4>
                                        <div style={{ ...iconTextStyle, fontSize: "14px" }}>
                                            <FiMail
                                                style={{ marginBottom: "20px", fontSize: "18px" }}
                                            />
                                            <p>
                                                <a
                                                    href={`mailto:${contactInfo.email}`}
                                                    style={{ color: "blue" }}
                                                >
                                                    {contactInfo.email}
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="phone">
                                        <h4 style={{ fontSize: "18px" }}>No Telp:</h4>
                                        <div style={{ ...iconTextStyle, fontSize: "14px" }}>
                                            <FiSmartphone
                                                style={{ marginBottom: "20px", fontSize: "18px" }}
                                            />
                                            <p>021 4600 464</p>
                                        </div>
                                    </div>
                                    <div className="work-hours">
                                        <h4 style={{ fontSize: "18px" }}>Jam Kerja:</h4>
                                        <div style={{ ...iconTextStyle, fontSize: "14px" }}>
                                            <FiClock
                                                style={{ marginBottom: "20px", fontSize: "18px" }}
                                            />
                                            <p
                                                dangerouslySetInnerHTML={{
                                                    __html: contactInfo.jamkerja,
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col md="6" data-aos="fade-left" style={{ marginTop: "30px" }}>
                                <Form onSubmit={sendEmail} innerRef={form}>
                                    <FormGroup>
                                        <Label for="name">Nama</Label>
                                        <Input type="text" name="user_name" id="name" required />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="email">Email</Label>
                                        <Input type="email" name="user_email" id="email" required />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="subject">Subjek</Label>
                                        <Input type="text" name="subject" id="subject" required />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="message">Pesan</Label>
                                        <Input type="textarea" name="message" rows={5} required />
                                    </FormGroup>
                                    <div className="text-center">
                                        <Button type="submit" color="primary">
                                            Send Message
                                        </Button>
                                    </div>
                                </Form>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <DefaultFooter />
            </div>
        </>
    );
};

export default ContactPage;
